import { HeroCTA } from '@/components/modules/HeroCTA';
import dynamic from 'next/dynamic';
import { ModuleDictionary } from '../types/module';

const RawHtmlComponent = dynamic(
  () =>
    import(/* webpackChunkName: "rawhtml_module" */ '@/components/modules/RawHtml').then(
      (mod) => mod.RawHtml,
    ),
  { ssr: true },
);

const RichTextComponent = dynamic(
  () =>
    import(/* webpackChunkName: "richtext_module" */ '@/components/modules/RichText').then(
      (mod) => mod.RichText,
    ),
  { ssr: true },
);

const StandardCtaComponent = dynamic(
  () =>
    import(/* webpackChunkName: "standardcta_module" */ '@/components/modules/StandardCTA').then(
      (mod) => mod.StandardCTA,
    ),
  { ssr: true },
);

const PricingComponent = dynamic(
  () =>
    import(/* webpackChunkName: "pricing_module" */ '@/components/modules/Pricing').then(
      (mod) => mod.Pricing,
    ),
  { ssr: true },
);

const ProductHighlightComponent = dynamic(
  () =>
    import(
      /* webpackChunkName: "producthighlight_module" */ '@/components/modules/ProductHighlight'
    ).then((mod) => mod.ProductHighlight),
  { ssr: true },
);

const FeatureComponent = dynamic(
  () =>
    import(/* webpackChunkName: "feature_module" */ '@/components/modules/Feature').then(
      (mod) => mod.Feature,
    ),
  { ssr: true },
);

const ProductBenefitsComponent = dynamic(
  () =>
    import(
      /* webpackChunkName: "productbenefits_module" */ '@/components/modules/ProductBenefits'
    ).then((mod) => mod.ProductBenefits),
  { ssr: true },
);

const ResourceComponent = dynamic(
  () =>
    import(/* webpackChunkName: "resource_module" */ '@/components/modules/Resource').then(
      (mod) => mod.Resource,
    ),
  { ssr: true },
);

const BlogCtaComponent = dynamic(
  () =>
    import(/* webpackChunkName: "blogcta_module" */ '@/components/modules/BlogCTA').then(
      (mod) => mod.BlogCTA,
    ),
  { ssr: true },
);

const TestimonialsComponent = dynamic(
  () =>
    import(/* webpackChunkName: "testimonials_module" */ '@/components/modules/Testimonials').then(
      (mod) => mod.Testimonials,
    ),
  { ssr: true },
);

const ExpansionPanel = dynamic(
  () =>
    import(
      /* webpackChunkName: "expansionpanel_module" */ '@/components/modules/ExpansionPanel'
    ).then((mod) => mod.ExpansionPanel),
  { ssr: true },
);

const KPIComponent = dynamic(
  () =>
    import(/* webpackChunkName: "kpi_module" */ '@/components/modules/KPI').then((mod) => mod.KPI),
  { ssr: true },
);

const InterlinkingModuleComponent = dynamic(
  () =>
    import(
      /* webpackChunkName: "interlinkingcard_module" */ '@/components/modules/InterlinkingCard'
    ).then((mod) => mod.InterlinkingCard),
  { ssr: true },
);

const ThreeColumnModuleComponent = dynamic(
  () =>
    import(/* webpackChunkName: "threecolumn_module" */ '@/components/modules/ThreeColumn').then(
      (mod) => mod.ThreeColumn,
    ),
  { ssr: true },
);

const BrandsComponent = dynamic(
  () =>
    import(/* webpackChunkName: "brands_module" */ '@/components/modules/Brands').then(
      (mod) => mod.Brands,
    ),
  { ssr: true },
);

const FormComponent = dynamic(
  () =>
    import(/* webpackChunkName: "form_module" */ '@/components/modules/Form').then(
      (mod) => mod.Form,
    ),
  { ssr: true },
);

const VideoModuleComponent = dynamic(
  () =>
    import(/* webpackChunkName: "video_module" */ '@/components/modules/VideoModule').then(
      (mod) => mod.VideoModule,
    ),
  { ssr: true },
);

const ComparisonTableComponent = dynamic(
  () =>
    import(
      /* webpackChunkName: "comparisonTable_module" */ '@/components/modules/ComparisonTable'
    ).then((mod) => mod.ComparisonTable),
  { ssr: true },
);

/**
 * Map CMS Module type to React Component
 */
const MODULE_TYPE_TO_COMPONENT: ModuleDictionary = {
  RawHtmlModule: RawHtmlComponent,
  RichTextModule: RichTextComponent,
  StandardCtaModuleV2: StandardCtaComponent,
  PricingModuleV2: PricingComponent,
  ProductHighlightModuleV2: ProductHighlightComponent,
  FeatureModuleV2: FeatureComponent,
  ProductBenefitsModuleV2: ProductBenefitsComponent,
  ResourceModuleV2: ResourceComponent,
  BlogModuleV2: BlogCtaComponent,
  TestimonialsModuleV2: TestimonialsComponent,
  FaqModuleV2: ExpansionPanel,
  HeroCtaModuleV2: HeroCTA,
  KpiModuleV2: KPIComponent,
  InterlinkingModuleV2: InterlinkingModuleComponent,
  ThreeColumnModuleV2: ThreeColumnModuleComponent,
  BrandsModuleV2: BrandsComponent,
  FormModuleV2: FormComponent,
  VideoModuleV2: VideoModuleComponent,
  ComparisonTableV2: ComparisonTableComponent,
};

/**
 * Get corresponding React Component based on Module Type in CMS
 */
export const getModuleComponent = (type: string) => {
  if (!Object.prototype.hasOwnProperty.call(MODULE_TYPE_TO_COMPONENT, type)) {
    console.warn('[getModuleComponent] MODULE_TYPE_TO_COMPONENT not found for ', type);
    return;
  }

  return MODULE_TYPE_TO_COMPONENT[type as keyof ModuleDictionary];
};
